import {logFeatureFlagEvaluation} from './util/datadog/datadogRumFlagEval';

/** Logs every server-evaluated startup feature flag injected into the page. */
export function logStartupFeatureFlagEvaluations(): void {
  const featureFlags =
    typeof window === 'undefined' ? {} : (window.CONFIG?.FEATURE_FLAGS ?? {});
  for (const [key, value] of Object.entries(featureFlags)) {
    logFeatureFlagEvaluation(key, value);
  }
}
